module.exports = __webpack_public_path__ + "assets/img/llfour.4c0aba19.png";